// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
//Last ADD : NEW'
// MODFIED DATA : 14-08-2025
const AutoLoanCollectionActionTypes = {
	/*************** Get Auto Loan Collection Details Start ******************/
	GET_AUTO_LOAN_REPORT_DETAILS_START: 'get_auto_loan_collection_report_details_start',
	GET_AUTO_LOAN_REPORT_DETAILS_SUCCESS: 'get_auto_loan_collection_report_details_success',
	GET_AUTO_LOAN_REPORT_DETAILS_FAILURE: 'get_auto_loan_collection_report_details_failure',
	GET_AUTO_LOAN_REPORT_DETAILS_RESPONSE_RESET:
		'get_auto_loan_collection_report_details_response_reset',
	GET_AUTO_LOAN_REPORT_DETAILS_RESPONSE_CHANGED:
		'get_auto_loan_collection_report_details_response_changed',
	/*************** Get Auto Loan Collection Details End ******************/
};
export default AutoLoanCollectionActionTypes;
